import * as React from "react";

function SvgTemperature(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.09 6.59a2 2 0 00-2-2h-2.18a2 2 0 00-2 2v11.237a6.182 6.182 0 106.182 0L20.09 6.589zm-4.636 6.774a1 1 0 011-1h1.091a1 1 0 011 1v5.445A4.638 4.638 0 0117 27.82a4.636 4.636 0 01-1.546-9.01v-5.446z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.833A2.833 2.833 0 012.833 0h28.334A2.833 2.833 0 0134 2.833v28.334A2.833 2.833 0 0131.167 34H2.833A2.833 2.833 0 010 31.167V2.833zm15.364.258a3 3 0 00-3 3v10.908a7.727 7.727 0 109.273 0V6.091a3 3 0 00-3-3h-3.273zm9.863 3.09a.5.5 0 00-.5.5v.546a.5.5 0 00.5.5h5.182a.5.5 0 00.5-.5v-.545a.5.5 0 00-.5-.5h-5.182zm-.5 5.137a.5.5 0 01.5-.5h3.637a.5.5 0 01.5.5v.546a.5.5 0 01-.5.5h-3.637a.5.5 0 01-.5-.5v-.546zm.5 4.136a.5.5 0 00-.5.5v.546a.5.5 0 00.5.5h5.182a.5.5 0 00.5-.5v-.546a.5.5 0 00-.5-.5h-5.182z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgTemperature;
